import { Pipe, PipeTransform } from '@angular/core';
import { TrafficModel } from '../shared/models/traffic-related/TrafficModel';

@Pipe({
    name: 'sorttraffic',
    pure: false
})
export class SortTrafficPipe implements PipeTransform {

    transform(values: TrafficModel[]) {
        return values.sort((a: TrafficModel, b: TrafficModel) => {
            return new Date(b.TimeStamp).getMilliseconds() - new Date(a.TimeStamp).getMilliseconds();
        });
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/pipes/date-sort.pipe.ts